import React from 'react';
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Programs", path: "/program" },
    { label: "Contact", path: "/contact" },
    { label: "Register", path: "/register", special: true },
  ];

  return (
    <header className="w-full bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <img src="./images/logo.png" alt="Logo" className="h-12 animate-[float_3s_ease-in-out_infinite]" />
          <h1 className="text-black text-xl font-semibold tracking-wide">CTE 2025</h1>
        </div>

        <nav className="hidden md:flex space-x-6 text-sm text-gray-600">
          {navItems.map(({ label, path, special }) => (
            <Link
              key={path}
              to={path}
              className={`transition duration-300 pb-1 border-b-2 ${
                location.pathname === path
                  ? "border-blue-600 text-black"
                  : "border-transparent hover:border-gray-400 hover:text-black"
              } ${special ? "font-bold text-blue-500" : ""}`}
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
